import { cn } from 'src/utils/className';

interface LabelProps {
  children: React.ReactNode;
  className?: string;
  required?: boolean;
  htmlFor?: string;
}

export const Label = ({
  children,
  className,
  required,
  htmlFor,
}: LabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'block font-regular mb-2',
        required ? 'required-field' : '',
        className,
      )}
    >
      {children}
    </label>
  );
};
